import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { THEME_VARIANTS } from 'core/components/theme/theme-variant';
import { toSentenceCase } from 'core/helpers/sentence-case';

import useStyles from './header-tab.styles';

const MenuItem = ({ smallPadding, iconSize, iconSrc, ReskinIcon, label, ...props }) => {
  const classes = useStyles(smallPadding);
  const isReskin = useTheme().themeVariant === THEME_VARIANTS.RESKIN;
  const tabClasses = useMemo(() => {
    const { smallIcon, largeIcon, reskinIcon, label: labelClass, ...otherClasses } = classes;
    return otherClasses;
  }, [classes]);
  return (
    <Tab
      classes={tabClasses}
      label={
        <>
          {/* The new-look icon is inline so it takes the tab's text color, bark when selected. */}
          {isReskin && ReskinIcon ? (
            <ReskinIcon className={classes.reskinIcon} aria-hidden="true" />
          ) : (
            <img className={iconSize === 'large' ? classes.largeIcon : classes.smallIcon} src={iconSrc} alt={label} />
          )}
          <span className={classes.label}>{isReskin ? toSentenceCase(label) : label}</span>
        </>
      }
      {...props}
    />
  );
};

MenuItem.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  ReskinIcon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  iconSize: PropTypes.oneOf(['large', 'small']),
  smallPadding: PropTypes.bool
};

MenuItem.defaultProps = {
  iconSize: 'large',
  ReskinIcon: null,
  smallPadding: false
};

export default MenuItem;
